import React from 'react';

const theme = {
  primary: "#E8540A",
  primaryLight: "#FF6B2B",
  bg: "#FFFAF5",
  cardBg: "#FFFFFF",
  cardHeaderBg: "#FFF0E8",
  text: "#1A0A00",
  textMuted: "#5A3A20",
  textLight: "#8B6040",
  border: "#F0D0B0",
  gradient: "linear-gradient(135deg, #E8540A 0%, #FF8C42 100%)",
};

const PersonIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="24" height="24">
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
  </svg>
);

const GroupIcon = () => (
  <svg viewBox="0 0 24 24" fill="white" width="22" height="22">
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
  </svg>
);

const LocationIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
    <path d="M10 20S3 10.87 3 7a7 7 0 1 1 14 0c0 3.87-7 13-7 13zm0-11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
  </svg>
);

const PhoneIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width={size} height={size}>
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);

const contacts = [
  {
    role: "प्रतिष्ठाचार्य",
    roleEn: "Pratisthaacharya",
    name: "पं. श्री सागर पद्माण्णा उपाध्ये",
    nameEn: "Pandit Shri Sagar Padmanna Upadhye",
    location: "चिंचवाडकर, पुणे",
    phone: "7972970108",
  },
  {
    role: "निर्देशन",
    roleEn: "Direction",
    name: "श्री. पियुष सागर उपाध्ये",
    nameEn: "Shri Piyush Sagar Upadhye",
    location: "पुणे",
    phone: "8468933143",
  },
  {
    role: "विधानाचार्य",
    roleEn: "Vidhanacharya",
    name: "पं. श्री अभयकुमार महावीर उपाध्ये",
    nameEn: "Pandit Shri Abhaykumar Mahavir Upadhye",
    location: "वसगडे",
    phone: "9822339632",
  },
  {
    role: "व्यवस्थापन",
    roleEn: "Management",
    name: "श्री सिद्धांत अभयकुमार उपाध्ये",
    nameEn: "Shri Siddhant Abhaykumar Upadhye",
    location: "सांगवडेवाडी",
    phone: "7666724430",
  },
];

export default function ContactPage() {
  return (
    <div style={{
      minHeight: "100vh",
      backgroundColor: theme.bg,
      fontFamily: "'Noto Sans Devanagari', 'Segoe UI', sans-serif",
      color: theme.text,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700;800&family=Noto+Serif+Devanagari:wght@400;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        .contact-header {
          text-align: center;
          padding: 72px 24px 52px;
          max-width: 700px;
          margin: 0 auto;
        }

        .eyebrow {
          font-size: 18px;
          letter-spacing: 3px;
          color: ${theme.primary};
          font-weight: 600;
          margin-bottom: 14px;
          text-transform: uppercase;
        }

        .hero-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: clamp(36px, 5.5vw, 60px);
          font-weight: 700;
          color: ${theme.text};
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .title-divider {
          width: 56px;
          height: 3px;
          background: ${theme.primary};
          margin: 0 auto 24px;
          border-radius: 2px;
        }

        .subtitle {
          font-size: 16px;
          color: ${theme.textMuted};
          line-height: 1.7;
        }

        .contact-grid-wrap {
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 24px 48px;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 22px;
          margin-bottom: 40px;
        }

        .contact-card {
          background: #fff;
          border: 1.5px solid ${theme.border};
          border-radius: 16px;
          overflow: hidden;
          transition: all 0.28s ease;
          cursor: default;
        }

        .contact-card:hover {
          border-color: ${theme.primary};
          box-shadow: 0 8px 28px rgba(232,84,10,0.1);
          transform: translateY(-3px);
        }

        .card-top {
          background: ${theme.cardHeaderBg};
          padding: 24px 16px 20px;
          text-align: center;
          border-bottom: 1px solid ${theme.border};
        }

        .avatar-circle {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: ${theme.gradient};
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 12px;
          box-shadow: 0 4px 14px rgba(232,84,10,0.3);
        }

        .role-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 16px;
          font-weight: 700;
          color: ${theme.text};
          margin-bottom: 3px;
        }

        .role-subtitle {
          font-size: 12.5px;
          color: ${theme.primary};
          font-style: italic;
        }

        .card-body {
          padding: 20px 18px 22px;
        }

        .person-name {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 14.5px;
          font-weight: 700;
          color: ${theme.text};
          margin-bottom: 4px;
          line-height: 1.4;
        }

        .person-name-en {
          font-size: 12px;
          color: ${theme.textLight};
          margin-bottom: 14px;
          line-height: 1.4;
        }

        .info-row {
          display: flex;
          align-items: center;
          gap: 7px;
          margin-bottom: 8px;
          font-size: 13.5px;
          color: ${theme.textMuted};
          text-decoration: none;
        }

        .info-row.phone {
          color: ${theme.primary};
          font-weight: 700;
          font-size: 14px;
        }

        .info-row svg {
          flex-shrink: 0;
          opacity: 0.7;
        }

        .bottom-section {
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 24px 80px;
          display: grid;
          grid-template-columns: 1fr 2fr;
          gap: 24px;
          align-items: start;
        }

        .sanstha-card {
          background: #fff;
          border: 1.5px solid ${theme.border};
          border-radius: 16px;
          padding: 22px 22px 24px;
          transition: all 0.28s ease;
        }

        .sanstha-card:hover {
          border-color: ${theme.primary};
          box-shadow: 0 6px 22px rgba(232,84,10,0.09);
        }

        .sanstha-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 16px;
        }

        .sanstha-icon {
          width: 42px;
          height: 42px;
          border-radius: 10px;
          background: ${theme.gradient};
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .sanstha-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 16px;
          font-weight: 700;
          color: ${theme.text};
        }

        .sanstha-list {
          list-style: none;
          padding: 0;
        }

        .sanstha-list li {
          font-size: 14px;
          color: ${theme.textMuted};
          padding: 4px 0 4px 16px;
          position: relative;
          line-height: 1.6;
        }

        .sanstha-list li::before {
          content: '•';
          position: absolute;
          left: 0;
          color: ${theme.primary};
          font-size: 15px;
          line-height: 1.4;
        }

        .cta-banner {
          background: ${theme.gradient};
          border-radius: 18px;
          padding: 36px 40px;
          position: relative;
          overflow: hidden;
        }

        .cta-om {
          position: absolute;
          right: 30px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 80px;
          color: rgba(255,255,255,0.15);
          font-family: 'Noto Serif Devanagari', serif;
          pointer-events: none;
          user-select: none;
          line-height: 1;
        }

        .cta-title {
          font-family: 'Noto Serif Devanagari', serif;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          margin-bottom: 12px;
        }

        .cta-text {
          font-size: 14.5px;
          color: rgba(255,255,255,0.92);
          line-height: 1.7;
          margin-bottom: 22px;
          max-width: 500px;
        }

        .call-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #fff;
          color: ${theme.primary};
          text-decoration: none;
          border-radius: 30px;
          padding: 11px 24px;
          font-size: 14.5px;
          font-weight: 700;
          cursor: pointer;
          font-family: 'Noto Sans Devanagari', sans-serif;
          transition: all 0.2s ease;
        }

        .call-btn:hover {
          background: #FFF5EE;
          transform: scale(1.03);
          box-shadow: 0 4px 16px rgba(0,0,0,0.15);
        }

        @media (max-width: 900px) {
          .contact-grid { grid-template-columns: repeat(2, 1fr); }
          .bottom-section { grid-template-columns: 1fr; }
        }

        @media (max-width: 500px) {
          .contact-grid { grid-template-columns: 1fr; }
          .cta-banner { padding: 28px 20px; }
          .cta-om { display: none; }
        }
      `}</style>

      {/* Header Section */}
      <div className="contact-header">
        <p className="eyebrow">सं प र्क  क रा</p>
        <h1 className="hero-title">आमच्याशी एकरूप व्हा</h1>
        <div className="title-divider" />
        <p className="subtitle">आम्हाला संपर्क साधण्यासाठी खालील माहिती वापरा</p>
      </div>

      {/* Contact Cards Section */}
      <div className="contact-grid-wrap">
        <div className="contact-grid">
          {contacts.map((c, i) => (
            <div key={i} className="contact-card">
              <div className="card-top">
                <div className="avatar-circle"><PersonIcon /></div>
                <p className="role-title">{c.role}</p>
                <p className="role-subtitle">{c.roleEn}</p>
              </div>
              <div className="card-body">
                <p className="person-name">{c.name}</p>
                <p className="person-name-en">{c.nameEn}</p>
                <div className="info-row">
                  <LocationIcon />
                  <span>{c.location}</span>
                </div>
                {c.phone && (
                  <a href={`tel:${c.phone}`} className="info-row phone">
                    <PhoneIcon />
                    <span>{c.phone}</span>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Footer Section */}
      <div className="bottom-section">
        <div className="sanstha-card">
          <div className="sanstha-header">
            <div className="sanstha-icon"><GroupIcon /></div>
            <p className="sanstha-title">संबंधित संस्था</p>
          </div>
          <ul className="sanstha-list">
            <li>सरस्वती नमःस्तुभ्यं जैन पुरोहित समिती</li>
            <li>सन्मतीनंदन गोशाळा</li>
          </ul>
        </div>

        <div className="cta-banner">
          <div className="cta-om">ॐ</div>
          <p className="cta-title">जय जिनेंद्र!</p>
          <p className="cta-text">
            आपल्या आध्यात्मिक प्रवासात आम्ही आपली सेवा करण्यास तत्पर आहोत. कोणत्याही प्रश्नासाठी किंवा मार्गदर्शनासाठी आमच्याशी संपर्क साधा.
          </p>
          {/* Main Calling Button with tel protocol */}
          <a href="tel:7972970108" className="call-btn">
            <PhoneIcon size={15} />
            आत्ताच कॉल करा
          </a>
        </div>
      </div>
    </div>
  );
}